export const NAV_LINKS = [
  { label: 'Features', href: '#features' },
  { label: 'How it works', href: '#how-it-works' },
  { label: 'Pricing', href: '#pricing' },
];

export const FEATURES = [
  {
    icon: '🧠',
    title: 'AI That Knows Your Child',
    description:
      "Not generic tips. Real advice based on your child's age, personality, and actual pattern history.",
  },
  {
    icon: '⏰',
    title: 'Smart Reminders That Learn',
    description:
      'Our AI studies when accidents happen and reminds you 15 minutes before. Not a dumb 2-hour alarm.',
  },
  {
    icon: '👶',
    title: 'Child Mode Kids Love',
    description:
      'A friendly pet companion, sticker rewards, and celebration animations make the potty feel exciting - not scary.',
  },
  {
    icon: '👨‍👩‍👧',
    title: 'Co-Parent Sync',
    description:
      'Both parents, grandparents, and caregivers stay in sync automatically. One logs - everyone knows instantly.',
  },
  {
    icon: '🌙',
    title: 'Night Training Module',
    description:
      "Most apps ignore night training. We don't. Get specific guidance and tracking for dry nights too.",
  },
  {
    icon: '📊',
    title: 'Real Progress Tracking',
    description:
      "See patterns in a clean dashboard. Know which days are hardest, what time accidents peak, and how far you've come.",
  },
];

export const HOW_IT_WORKS_STEPS = [
  {
    number: '01',
    icon: '📱',
    title: 'Download & set up',
    description:
      "Create your account and enter your child's name, age, and a quick 5-question readiness quiz.",
  },
  {
    number: '02',
    icon: '🚽',
    title: 'Log every potty moment',
    description:
      "One tap to log success, accident, or attempt. The AI starts learning your child's pattern immediately.",
  },
  {
    number: '03',
    icon: '🧠',
    title: 'Get smarter every day',
    description:
      'After just 10 logs, reminders become personalized. After 30, the AI can predict accidents before they happen.',
  },
];

export const TESTIMONIALS = [
  {
    initials: 'SM',
    colorClass: 'bg-[#FF7B5B]',
    name: 'Sarah M.',
    role: 'Mom of 2, London',
    quote:
      'I tried 4 other apps. PottyPal is the only one that actually understands my son. The AI noticed he always has accidents at 4pm - now we do a potty trip at 3:45 every day. Game changer.',
  },
  {
    initials: 'PK',
    colorClass: 'bg-[#5B3FA6]',
    name: 'Priya K.',
    role: 'Mom, Dubai',
    quote:
      "My husband and I both use it and everything syncs instantly. No more 'did you take her to the potty?' arguments. We can both see everything in real time.",
  },
  {
    initials: 'AR',
    colorClass: 'bg-teal-500',
    name: 'Ahmed R.',
    role: 'Dad, Karachi',
    quote:
      "The child mode is brilliant. My daughter asks to open the app now because she loves feeding her pet stickers. She's trained in 3 weeks.",
  },
];

export const PLANS = [
  {
    name: 'FREE',
    badge: 'Always Free',
    price: '$0',
    subtitle: '',
    trial: '',
    buttonLabel: 'Download Free',
    buttonVariant: 'solid',
    buttonHref: '#playstore',
    features: [
      'Smart potty timer',
      'Basic logging (3/day)',
      'Daily AI tip',
      'Sticker rewards for child',
      '7-day progress view',
    ],
  },
  {
    name: 'PREMIUM',
    badge: 'Most Popular',
    price: '$4.99/mo',
    subtitle: 'or $29.99/year (save 50%)',
    trial: '7-day free trial',
    buttonLabel: 'Start Free Trial',
    buttonVariant: 'solid',
    buttonHref: '#playstore',
    highlighted: true,
    features: [
      'Unlimited logging',
      'AI Coach chat (ask anything)',
      'Full progress analytics',
      'Pattern detection',
      'Custom training plan',
      'Co-parent sync',
      'Night training module',
      'Printable sticker charts',
    ],
  },
  {
    name: 'PRO FAMILY',
    badge: '',
    price: '$8.99/mo',
    subtitle: 'or $49.99/year',
    trial: '',
    buttonLabel: 'Get Pro',
    buttonVariant: 'outline',
    buttonHref: '#playstore',
    features: [
      'Up to 5 child profiles',
      'Up to 3 caregivers',
      'Milestone celebration videos',
      'AI audio bedtime stories',
      'Regression support module',
    ],
  },
];

export const FAQ_ITEMS = [
  {
    question: "Is my child's data safe?",
    answer:
      'Yes. All data is encrypted and stored securely using Google Firebase. We are COPPA compliant - child data is always under parental control. You can export or delete all data at any time from Settings.',
  },
  {
    question: 'Does it work if I have no internet?',
    answer:
      'Yes! Logging, timer, and reminders all work fully offline. Data syncs automatically when you reconnect.',
  },
  {
    question: 'At what age should I start potty training?',
    answer:
      'Most children show readiness between 18-30 months, but every child is different. Our readiness quiz helps you know if the time is right. The app works for children up to 4 years.',
  },
  {
    question: 'Can both parents use the same account?',
    answer:
      'Yes - the co-parent sync feature (Premium) lets up to 3 caregivers share one baby profile. Everything logs in real time.',
  },
  {
    question: 'What makes this different from other potty training apps?',
    answer:
      "Most apps are just alarm clocks or static tip lists. PottyPal's AI learns your specific child's pattern. It sends reminders at the right moment - before accidents happen, not on a fixed schedule.",
  },
  {
    question: 'Is it available on iPhone?',
    answer:
      'Yes — PottyPal is available on iPhone and Android. Download free from the App Store or Google Play.',
  },
];

